import React, { useEffect } from 'react';
import { getReturnToUrl } from 'src/dataLayer/localData/queryParams';
import Loader from 'src/viewLayer/components/shared/Loader';

/*
 * Used as the default redirect handler for authenticated
 * pages. Does not create a history item.
 */

export default function AuthenticatedRedirect() {
  useEffect(() => {
    const timeoutRef = setTimeout(() => {
      window.location.replace(getReturnToUrl(window.location.search, false));
    }, 2000);

    return () => clearTimeout(timeoutRef);
  }, []);

  return (<Loader />);
};
